<template>
    <div class="container-fluid mt-6 px-5">
        <div id="lower-div" class="row mt-3">
            <div class="card mb-4">
                <div v-loading="loading">
                    <div class="p-2" m="4">
                        <div class="card-body px-0 pt-0 pb-3">
                            <titles text="Təqvim jurnalı" />
                            <hr style="margin-top:0;margin-bottom: 15px;" />
                            <div class="filter-section mb-3">
                                <div class="row g-3 align-items-end">
                                    <div class="col-md-2">
                                        <label class="form-label">Tarixdən</label>
                                        <el-date-picker v-model="dateFrom" size="large" type="date" placeholder="Seçin"
                                            format="DD.MM.YYYY" value-format="YYYY-MM-DD" style="width: 100%" />
                                    </div>
                                    <div class="col-md-2">
                                        <label class="form-label">Tarixədək</label>
                                        <el-date-picker v-model="dateTo" size="large" type="date" placeholder="Seçin"
                                            format="DD.MM.YYYY" value-format="YYYY-MM-DD" style="width: 100%" />
                                    </div>
                                    <div class="col-md-2">
                                        <label class="form-label">Kateqoriya</label>
                                        <el-select v-model="searchType" size="large" placeholder="Seçin"
                                            style="width: 100%">
                                            <el-option v-for="item in categoryOptions" :key="item.value"
                                                :label="item.label" :value="item.value" />
                                        </el-select>
                                    </div>
                                    <div class="col-md-5 d-flex justify-content-start align-items-center">
                                        <soft-button type="button" @click="applyFilters">
                                            <i class="fas fa-search"></i> Axtar
                                        </soft-button>
                                        <soft-button type="button" class="ms-2 btn-excel" @click="exportToExcel">
                                            <i class="fas fa-file-excel"></i>
                                        </soft-button>
                                    </div>

                                </div>
                            </div>
                            <calendar-journal-table :data="calendarItems" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Titles from '@/project/Components/Titles.vue';
import SoftButton from "@/components/SoftButton.vue";
import CalendarJournalTable from '@/project/Components/Tables/CalendarJournalTable.vue';
import { GetCalendarJournal } from '@/project/Source/journals';
import * as XLSX from "xlsx";
import { respUsers } from "@/project/Source/helper";

export default {
    components: {
        Titles,
        SoftButton,
        CalendarJournalTable
    },
    data() {
        const today = new Date();
        const threeMonthsAgo = new Date();
        threeMonthsAgo.setMonth(today.getMonth() - 3);

        const pad = n => n.toString().padStart(2, '0');
        const todayStr = `${today.getFullYear()}-${pad(today.getMonth() + 1)}-${pad(today.getDate())}`;
        const threeMonthsAgoStr = `${threeMonthsAgo.getFullYear()}-${pad(threeMonthsAgo.getMonth() + 1)}-${pad(threeMonthsAgo.getDate())}`;

        return {
            calendarItems: [],
            loading: false,
            dateFrom: threeMonthsAgoStr,
            dateTo: todayStr,
            searchType: 0,
            categoryOptions: [
                { value: 0, label: 'Hamısı' },
                { value: 1, label: 'Ödəniş' },
                { value: 2, label: 'İclaslar' },
                { value: 3, label: 'Təqvim' },
            ]
        };
    },
    mounted() {
        this.fetchCalendarItems();
    },
    methods: {
        getRespName(id) {
            const u = respUsers.find(x => x.id === id)
            return u ? u.name : null
        },
        formatDateTime(date) {
            if (!date) return "";
            const d = new Date(date);
            const day = String(d.getDate()).padStart(2, '0');
            const month = String(d.getMonth() + 1).padStart(2, '0');
            const year = d.getFullYear();
            const hour = String(d.getHours()).padStart(2, '0');
            const min = String(d.getMinutes()).padStart(2, '0');
            return `${day}.${month}.${year} ${hour}:${min}`;
        },
        exportToExcel() {
            if (!this.calendarItems || !this.calendarItems.length) return;

            const data = this.calendarItems.map(x => ({
                "№": x.subrogationNumber,
                "Kateqoriya": x.category,
                "Tarix": this.formatDateTime(x.date),
                "Təsvir": x.description,
                "Məsul şəxs": x.responsibleName
            }));

            // Генерация книги и листа
            const ws = XLSX.utils.json_to_sheet(data);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "Təqvim");

            XLSX.writeFile(wb, "teqvim_jurnali.xlsx");
        },
        fetchCalendarItems() {
            this.loading = true
            const params = {
                dateFrom: this.dateFrom,
                dateTo: this.dateTo,
                searchType: this.searchType,
                requestCorrelationId: crypto.randomUUID()
            }
            GetCalendarJournal(params)
                .then(res => {
                    this.calendarItems = (res.data.data || []).map(it => ({
                        ...it,
                        responsibleName: this.getRespName(it.respUserId)
                    }))
                })
                .catch(err => console.error(err))
                .finally(() => {
                    this.loading = false
                })
        },
        applyFilters() {
            this.fetchCalendarItems();
        }
    }
};
</script>

<style scoped>
.form-label {
    font-weight: 600;
    margin-bottom: 5px;
}
</style>
